import { render, staticRenderFns } from "./PromoSettings.vue?vue&type=template&id=fb1e2a78&scoped=true&"
import script from "./PromoSettings.vue?vue&type=script&lang=js&"
export * from "./PromoSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1e2a78",
  null
  
)

export default component.exports